import { WHATSAPP_ACCOUNTS_URL } from 'constants/ApiConstants';
import type { ApiError, MetaAction, PageContent } from 'modules/global/generic.types';

import * as types from './actionTypes';
import type * as ActionType from './types';

export const fetchWhatsAppAccounts = (
  dealerId: string,
  params: ActionType.FetchWhatsAppAccountsParams,
  meta: MetaAction = {}
) => ({
  type: types.FETCH_WHATSAPP_ACCOUNTS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${WHATSAPP_ACCOUNTS_URL}/search/available`,
      params: {
        dealerId,
        ...params,
      }
    },
  },
  meta: {
    '@app-request': true,
    dealerId,
    ...meta,
  }
});

export const fetchDmsProviders = (
  dealerId: string,
  params: ActionType.FetchDmsProvidersParams,
  meta: MetaAction = {}
): ActionType.FetchDmsProvidersRequestAction => ({
  type: types.FETCH_DMS_PROVIDERS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: '/dmsProviders/api/filter',
      params,
    },
  },
  meta: {
    dealerId,
    ...meta,
  }
});

export const fetchDmsProvidersSuccess = (
  dmsProviders: PageContent<ActionType.DmsProvider>,
  meta: MetaAction = {}
): ActionType.FetchDmsProvidersSuccessAction => ({
  type: types.FETCH_DMS_PROVIDERS_SUCCESS,
  payload: dmsProviders,
  meta,
});

export const fetchDmsProvidersFailure = (
  error: ApiError,
  meta: MetaAction = {}
): ActionType.FetchDmsProvidersFailureAction => ({
  type: types.FETCH_DMS_PROVIDERS_FAILURE,
  payload: error,
  error: true,
  meta,
});
